import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as SuccessIcon } from "Assets/Icons/Settings/SuccessIcon.svg";

const DeleteExperience = ({ open, setOpen, onConfirm }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={Boolean(open)}
      onClose={() => handleClose()}
    >
      <DialogTitle>
        {" "}
        {Translation?.Delete}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle" fontWeight={500}>
          {Translation?.DeleteConfirmation}
        </Typography>
      </DialogContent>
      <DialogActions primary>
        <Button variant="contained" color="error" onClick={onConfirm}>
          {" "}
          {Translation?.YesDelete}
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleClose}>
          {Translation?.No}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteExperience;
